import { logout, getInfoRoles } from "../../apis/User";
import { useState, useEffect } from "react";
import "./index.css";
import { useTranslation } from "react-i18next";
import dashLogout from "../../assets/shapes_svg/dashboards/logoutIcon.svg";
const Username = () => {
  const [role, setRole] = useState("");
  const [name, setName] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    getInfoRoles(role, setRole, setName);
  }, []);
  return (
    <div className="usernametop">
      <div className="usernametop__hello">
        <h4>{t("HELLO")},</h4> <h4>{name}</h4>
      </div>
      <div className="usernametop__small">
        <div onClick={logout}>
          <img
            src={dashLogout}
            width={54}
            height={54}
            alt="logout icon"
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Username;
